import React, { useState } from "react";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";
import { FiTrash2 } from "react-icons/fi";


const storage = getStorage();

export default function EditClubInfoForm({ data, onSave, onCancel }) {
    const [form, setForm] = useState({ ...data });
    const [uploading, setUploading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleArrayChange = (field, index, value) => {
        const updated = [...(form[field] || [])];
        updated[index] = value;
        setForm((prev) => ({ ...prev, [field]: updated }));
    };

    const addArrayItem = (field) => {
        setForm((prev) => ({ ...prev, [field]: [...(prev[field] || []), ""] }));
    };

    const removeArrayItem = (field, index) => {
        const updated = [...(form[field] || [])];
        updated.splice(index, 1);
        setForm((prev) => ({ ...prev, [field]: updated }));
    };

    const handleLogoUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        if (file.size > 1024 * 1024) return alert("Max file size is 1MB");

        setUploading(true);
        const fileRef = ref(storage, `club_logos/${uuidv4()}_${file.name}`);
        const snap = await uploadBytes(fileRef, file);
        const url = await getDownloadURL(snap.ref);
        setForm((prev) => ({ ...prev, logo: url }));
        setUploading(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(form);
    };

    return (
        <form className="edit-form" onSubmit={handleSubmit}>
            <h4>Edit Club Info</h4>
            <label>Logo:</label><br />
            <input type="file" accept="image/*" onChange={handleLogoUpload} />
            {form.logo && <img src={form.logo} alt="Logo" style={{ width: 120, marginTop: 10 }} />}<br />

            <textarea
                name="description"
                value={form.description}
                onChange={handleChange}
                rows={4}
                style={{ width: "100%", padding: "8px", borderRadius: "6px", border: "1px solid #ccc" }}
            />

            <textarea name="vision" value={form.vision} onChange={handleChange} rows={4} style={{ width: "100%", padding: "8px", borderRadius: "6px", border: "1px solid #ccc" }}
            />

            {['values', 'mission', 'objective'].map((field) => (
                <div key={field} style={{ marginTop: 16 }}>
                    <label>{field.charAt(0).toUpperCase() + field.slice(1)}:</label>
                    {(form[field] || []).map((val, i) => (
                        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                            <input
                                value={val}
                                onChange={(e) => handleArrayChange(field, i, e.target.value)}
                                style={{
                                    flex: 1,
                                    padding: "6px 10px",
                                    borderRadius: "6px",
                                    border: "1px solid #ccc"
                                }}
                                placeholder={`Enter ${field}...`}
                            />
                            <FiTrash2
                                size={18}
                                onClick={() => removeArrayItem(field, i)}
                                title="Delete"
                                style={{ cursor: "pointer", color: "crimson" }}
                            />
                        </div>

                    ))}
                    <button
                        type="button"
                        onClick={() => addArrayItem(field)}
                        style={{
                            marginTop: "8px",
                            padding: "6px 12px",
                            borderRadius: "4px",
                            background: "#1e90ff",
                            color: "white",
                            border: "none",
                            cursor: "pointer"
                        }}
                    >
                        + Add
                    </button>
                </div>
            ))}

            <div className="participation-buttons" style={{ marginTop: 20 }}>
                <button type="submit" disabled={uploading}>Save</button>
                <button type="button" onClick={onCancel}>Cancel</button>
            </div>
        </form>
    );
}